import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginUserAdmin } from "../../service/endpoints";

export const loginhandler = createAsyncThunk('loginhandler', async (data, { rejectWithValue }) => {
  try {
    console.log('[Superadmin Login] Request payload:', { username: data?.username, organization_id: data?.organization_id });
    const response = await loginUserAdmin(data);
    // Backend body shape: { success, statusCode, message, data }
    const success = response?.success;
    const payload = response?.data;
    console.log('[Superadmin Login] API response:', { success, hasData: !!payload });
    if (success && payload) {
      sessionStorage.setItem('token', payload.access_token);
      sessionStorage.setItem('userdata', payload.role);
      const userInfo = payload.user ?? payload.user_details ?? {};
      sessionStorage.setItem('userdetails', JSON.stringify(userInfo));
      console.log('[Superadmin Login] Success:', response?.message ?? payload?.message);
      return userInfo;
    }
    console.warn('[Superadmin Login] API returned non-success:', response);
    return rejectWithValue(payload ?? response);
  } catch (error) {
    const fullError = {
      message: error?.message,
      response: error?.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : null,
      stack: error?.stack
    };
    console.error('[Superadmin Login] Full error:', fullError);
    if (error?.response !== null) {
      throw error;
    }
    throw error;
  }
});


const getLoginSlice = createSlice({
  name: 'getTicket',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    error: null
  },
  extraReducers: (builder) => {
    builder.addCase(loginhandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isError = false;
      state.error = null;
    });
    builder.addCase(loginhandler.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(loginhandler.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.error || action.payload;
      console.error('[Superadmin Login] Reducer rejected – full action:', {
        error: action.error,
        payload: action.payload,
        meta: action.meta
      });
    });
  }

});

export default getLoginSlice.reducer;